import { css } from "@emotion/css";
import { Colors, FontSizeInPx, FontWeight, LineHeightInPx } from "@snapchat/snap-design-system";

import { fontFamily } from "../../styles";

export const allLensesButton = css`
    > span {
        ${fontFamily};
        cursor: pointer;

        padding: 0;

        font-size: ${FontSizeInPx.REGULAR}px;
        font-weight: ${FontWeight.NORMAL};
        line-height: ${LineHeightInPx.REGULAR}px;
        color: ${Colors.Blue.V150};
    }
`;
